export const containerStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  padding: 2,
  borderRadius: 2,
  backgroundColor: palette.background.paper,
  border: `1px solid ${palette.warning.main}`,
  boxShadow: palette.shadow?.s,
});

export const headlineStyles = ({ palette }) => ({
  color: palette.text.primary,
});

export const hintStyles = ({ palette }) => ({
  color: palette.text.secondary,
});

export const argumentsStyles = ({ palette }) => ({
  color: palette.text.secondary,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  fontFamily: 'monospace',
  padding: 1.5,
  borderRadius: 1.5,
  backgroundColor: palette.background.default,
  border: `1px solid ${palette.divider}`,
});
